// src/pages/Home.jsx
import React from "react";
import './../styles/styles.css';
import logo from "../assets/logo-titre.png";
import logoBdx from "../assets/logo-titre-bdx.png";
import illustrationPC from "../assets/illustrationPC.png";
import AnimatedCounter from "../components/AnimatedCounter";
import { Link } from 'react-router-dom';

// Importez vos images ici
import stickerCriseAuSommet from '../assets/sticker-crise-au-sommet.png';
import stickerDangereuseCampagne from '../assets/sticker-dangereuse-campagne.png';
import stickerTragedieAuJardinZen from '../assets/sticker-tragedie-au-jardin-zen.png';
import stickerAssassinABord from '../assets/sticker-assassin-a-bord.png';
import iconSearch from '../assets/icon-search.png';
import iconUser from '../assets/icon-user.png';
import iconDownload from '../assets/icon-download.png';
import illustrationVideo from '../assets/video-website.mp4'; // <= NOUVEL IMPORT


export default function Home() {
  return (
    <div className="home-page">
      {/* 1. Section Héro */}
      <section className="section-black">
        <h2 className="text-center">Plongez dans un mystère captivant, sans bouger de votre salon </h2>

        {/* Conteneur Flex pour aligner le texte/CTA et l'image côte à côte sur PC */}
        <div className="hero-content">
          
          {/* Bloc de Texte et CTA (qui passera à gauche sur PC) */}
          <div className="text-and-cta">
            <p>
              Ne vous contentez pas de jouer ; incarnez un rôle, mentez avec conviction et démasquez le coupable. 
               <br /> La soirée que vos amis n'oublieront pas.
            </p>
            <a href="/store" className="cta-button">DÉCOUVRIR LES JEUX</a>
          </div>

          {/* Bloc d'Illustration (qui passera à droite sur PC) */}
          <div className="illustration-container">
            <video
              src={illustrationVideo} // Utilisez la source importée
              alt="Vidéo d'illustration du jeu de murder party en ligne." 
              className="illustration-video" // Ajoutez une classe pour le CSS
              
              // ----------------------------------------------------
              // ATTRIBUTS ESSENTIELS pour une vidéo d'arrière-plan/d'illustration
              // ----------------------------------------------------
              autoPlay      // Démarre la lecture automatiquement
              muted         // ESSENTIEL : Coupe le son (nécessaire pour autoPlay sur la plupart des navigateurs)
              playsInline   // Améliore la compatibilité mobile (lecture sans passer en plein écran)
              
            />
          </div>
        </div>
    </section>

      {/* 2. Section Bienvenue et Dernières Enquêtes - CREAM
      On passe sur une couleur plus douce pour introduire le concept et montrer les produits.
      Les deux sections sont regroupées pour éviter un saut de couleur prématuré.
      */}
      <section className="section-cream">
        <h2>Bienvenue dans la communauté Gioco Mortale</h2>
        <p>
          <strong className="bordeaux-strong">Passez une soirée d'enquête inoubliable. </strong>
          Gioco Mortale vous propose des <strong className="bordeaux-strong">scénarios originaux</strong> pour enquêter sur des crimes. Attention, l'un de vous est sûrement le coupable !
          <br /> <br /> Tout est inclus, <strong className="bordeaux-strong"> 100% prêt à l'emploi </strong> : Téléchargez, imprimez (ou envoyez en digital), et jouez ! Les kits comprennent les règles complètes, les livrets rôles, un guide détaillé pour l'organisateur (sans spoiler), et les éléments de preuves.
        </p>
        
        {/* Ajout d'une ligne de séparation subtile si besoin, ou on enchaîne directement */}
        
        <h2 style={{ marginTop: '50px' }}>NOS DERNIÈRES ENQUÊTES</h2>
        <div className="card-grid">
          <Link to="/store">
            <div className="game-card">
              <img src={stickerAssassinABord} alt="Assassin à Bord" />
            </div>
          </Link>
          <Link to="/store">
            <div className="game-card">
              <img src={stickerTragedieAuJardinZen} alt="Tragédie au Jardin Zen" />
            </div>
          </Link>
          <Link to="/store">
            <div className="game-card">
              <img src={stickerCriseAuSommet} alt="Crise au Sommet" />
            </div>
          </Link>
        </div>



        <h3>Ils ont enquêté avec nous</h3>
        <div className="card-grid avis-utilisateurs">
          <div className="avis">
            <p>"La murder party a été un moment incroyable ! Nous avons passé une soirée de folie, les énigmes étaient intelligentes et l’histoire captivante."</p>
            <span>- Camille R.</span>
          </div>
          <div className="avis">
            <p>"C’était une première pour moi et j’ai adoré ! Les personnages étaient super bien détaillés, l’intrigue prenante et les indices bien placés."</p>
            <span>- Julien M.</span>
          </div>
          <div className="avis">
            <p>"Une expérience immersive incroyable ! Chaque indice vous plonge davantage dans l’histoire, et l’excitation augmente au fur et à mesure."</p>
            <span>- Sophie L.</span>
          </div>
        </div>
      </section>




      {/* 3. Section "Pourquoi nous choisir ?" - BLACK
      Retour au noir pour le contraste et mettre en évidence les bénéfices clés (caractéristiques)
      */}
      <section className="section-black">
        <h2>POURQUOI CHOISIR GIOCO MORTALE ?</h2>
        <div className="card-grid">
          <div className="feature-card">
            <img src={iconSearch} alt="Scénarios Immersifs" className="sticker-icon" />
            <h3>SCÉNARIOS IMMERSIFS</h3>
            <p>Des intrigues captivantes qui vous plongent au cœur du mystère.</p>
          </div>
          <div className="feature-card">
            <img src={iconUser} alt="Ambiance Garantie" className="sticker-icon" />
            <h3>AMBIANCE GARANTIE</h3>
            <p>Une expérience ludique et conviviale pour vos soirées entre amis ou en famille.</p>
          </div>
          <div className="feature-card">
            <img src={iconDownload} alt="Téléchargement Instantané" className="sticker-icon" />
            <h3>TÉLÉCHARGEMENT INSTANTANÉ</h3>
            <p>Accédez à votre jeu immédiatement après l'achat et commencez à jouer sans attendre.</p>
          </div>
        </div>
      </section>

      
      {/* 4. Section Fonctionnement et Compteur + Connexion / Inscription - CREAM
      On explique le fonctionnement et on donne le CTA final pour s'inscrire/se connecter.
      Les deux sections sont aussi regroupées en couleur (même si la login-container est stylée différemment dans le CSS) pour une meilleure cohérence.
      */}
      <section className="section-compact-cream">
        <h2>Comment ça fonctionne ?</h2>
        <p>
          Avec <strong className="bordeaux-strong">Gioco Mortale</strong>, voyagez dans un univers d'enquête.
        </p>
        <p className="justified-text">
          Achetez une murder party, et partagez <strong className="bordeaux-strong">instantanément</strong> les livrets personnages avec vos amis. Chaque joueur doit être muni de son téléphone (recommandé) ou bien d'une tablette ou PC connecté à internet pour télécharger son livret personnage. Vous pouvez également imprimer les livrets personnage en avance !
        </p>
        <AnimatedCounter title="Murder Party jouées" target={500} duration={2000} />

        <p className="justified-text">
        Préparez-vous pour une session de jeu immersive de <strong className="bordeaux-strong">2 à 3 heures</strong>. Conçu pour les joueurs de <strong className="bordeaux-strong">16 ans et plus</strong>, ce jeu est parfait pour animer vos soirées <strong className="bordeaux-strong">en famille ou entre amis</strong>. Un point fort de cette formule est que l'organisateur n'est pas relégué au simple rôle d'arbitre : il peut, s'il le souhaite, endosser <strong className="bordeaux-strong">le rôle d'un personnage</strong> tout en supervisant le bon déroulement de l'enquête.
        </p>
      </section>
      




      {/* La div login-container suit logiquement la section d'explication. 
      On suppose qu'elle a un fond de la même couleur ou un style de carte qui se détache. */}
      <div className="login-container">
        <div className="login-card">
          <div style={{ textAlign: 'center'}}>
            <img src={logoBdx} alt="Gioco Mortale" className="App-logo" />
          </div>
          <h3>Commandez une Murder Party</h3>
          <p className="login-subtitle">
            Pas encore inscrit ? Créez votre compte pour accéder à nos meilleurs scénarios.
            <br />
            Déjà un compte ? Connectez-vous pour continuer.
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '15px' }}>
            <a href="/signup" className="cta-button" style={{ flex: 1 }}>S’inscrire</a>
            <a href="/login" className="cta-button" style={{ flex: 1 }}>Se connecter</a>
          </div>
        </div>
      </div>


      




    </div>
  );
}